import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useParams } from 'react-router-dom'

import { SupplierData } from '../features/selfservice/supplier/edit'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const SupplierPage: React.FC = () => {
  const { id } = useParams()

  if (!id) return <></>

  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <SupplierData id={id} />
    </ErrorBoundary>
  )
}
